var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 40,
    viewBox: "0 0 85 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1.52301 29.5C27.523 38 69.523 30 78.523 24M2.75433 25.0001C5.75433 23.0001 24.7543 18.0001 26.2543 17.5001C27.7543 17.0001 26.7543 15.0001 28.2543 14.5001C29.7543 14.0001 30.2543 16.5001 31.7543 16.0001C33.2543 15.5001 34.2543 15.0002 34.7543 14.5001C35.2543 14 35.2543 12.5 35.7543 12.5C36.2543 12.5 38.2543 13.5 39.2543 13C40.2543 12.5 41.2543 11.5 41.2543 11C41.2543 10.5 40.7543 9.5 41.2543 9C41.7543 8.5 42.7543 8.5 43.2543 8C43.7543 7.5 44.7543 1 47.2543 1C49.7543 1 52.2543 8 54.2543 10C56.2543 12 61.7543 14 64.2543 12.5C66.7543 11 67.2543 4 70.7543 3.5C74.2543 3 73.2543 4.5 73.2543 5C73.2543 5.5 71.2543 9.5 71.7543 11C72.2543 12.5 76.2543 9.5 77.2543 11C78.2543 12.5 78.7543 14.0002 78.2543 14.5001C77.7543 15 75.2543 15.5 75.7543 18C76.2543 20.5 77.2543 23.5 77.7543 24C78.2543 24.5 79.2543 23.5 80.7543 24.5C82.2543 25.5 84.7543 31 82.7543 34C80.7543 37 72.7543 37.5 69.7543 37.5C66.7543 37.5 34.7543 40 17.2543 36C6.75434 33.5 2.25433 33 1.25433 30.5C0.454332 28.5 1.70424 25.7001 2.75433 25.0001Z",
    stroke: "black",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoot);
export default __webpack_public_path__ + "static/media/Boot.6676dd84.svg";
export { ForwardRef as ReactComponent };